// extracted by mini-css-extract-plugin
module.exports =  {"popup-link":"_32bbee5fda--popup-link--S_Cdn"};